"use strict";

import angular from "angular";

import template from "./button-group-horizontal.component.html";
import "./themes/button-group-horizontal-dark.scss";
import "./themes/button-group-horizontal.scss";

export class ButtonGroupHorizontalComponent {
    constructor() {}

    $onInit() {}
}

ButtonGroupHorizontalComponent.$inject = [];

const name = "buttonGroupHorizontalComponent";
const def = {
    bindings: {
        items: "<",
        onClickItem: "&",
        loading: "<"
    },

    controller: ButtonGroupHorizontalComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
